import React, {useEffect, useRef, useState} from 'react';
import block from 'bem-cn-lite';
import {Text, Tooltip} from '@gravity-ui/uikit';
import {getActivatableProps} from '@hooks/keyboard';

import './ElementWithTooltip.scss';

const b = block('element-with-tooltip');

type TextColor = 'primary' | 'secondary';

interface ElementWithTooltipProps {
    comment: string;
    textColor?: TextColor;
    inheritColor?: boolean;
    textClassName?: string;
    wrapperClassName?: string;
    onClick?: React.MouseEventHandler<HTMLDivElement>;
    tooltipOpenDelay?: number;
    tooltipCloseDelay?: number;
}

export const ElementWithTooltip: React.FC<ElementWithTooltipProps> = ({
    comment,
    textColor = 'primary',
    inheritColor = false,
    textClassName,
    wrapperClassName,
    onClick,
    tooltipOpenDelay = 0,
    tooltipCloseDelay = 0
}) => {
    const textRef = useRef<HTMLDivElement>(null);
    const [isOverflowed, setIsOverflowed] = useState(false);
    const textProps = !inheritColor ? {color: textColor} : {};
    const textStyle = onClick ? {cursor: 'inherit'} : undefined;

    useEffect(() => {
        const el = textRef.current;
        if (el) {
            const isOverflowing =
                el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth;
            setIsOverflowed(isOverflowing);
        }
    }, [comment]);

    // Основной текстовый элемент с ref для измерения переполнения
    const textElement = (
        <Text
            variant="body-1"
            ref={textRef}
            {...textProps}
            className={textClassName || b('text-comment')}
            style={{
                ...textStyle,
                ...(wrapperClassName ? {display: 'inline'} : {})
            }}
        >
            {comment}
        </Text>
    );

    const elementContent =
        wrapperClassName || onClick ? (
            <span
                {...(onClick
                    ? getActivatableProps(() => onClick({} as React.MouseEvent<HTMLDivElement>))
                    : {})}
                className={wrapperClassName}
                style={onClick ? {cursor: 'pointer'} : undefined}
            >
                {textElement}
            </span>
        ) : (
            textElement
        );

    return isOverflowed ? (
        <Tooltip
            content={
                <Text variant="body-1" className={b('tooltip-comment-content')}>
                    {comment}
                </Text>
            }
            contentClassName={b('tooltip-comment')}
            className={b('tooltip-comment-container')}
            placement={['right-start', 'left-start']}
            openDelay={tooltipOpenDelay}
            closeDelay={tooltipCloseDelay}
        >
            {elementContent}
        </Tooltip>
    ) : (
        elementContent
    );
};
